<template>
  <div style="display: contents">
    <div class="meeting-left-top row-container ">
      <div class="row-left" style="">
        <h2 class="white--text">Dagordning</h2>
      </div>
      <div></div>
    </div>
    <div v-if="meeting.agenda.length > 0" class="meeting-left-content">
      <v-card
        v-for="item in agendaItems"
        :key="item.uid"
        :class="[activeAgenda === item.id ? '' : 'background--transparent']"
        style="margin-bottom: 12px; margin-right: 4px;"
      >
        <v-card-title class="subtitle-2" style="word-break: break-word;">
          <div class="agenda-item-container">
            <div class="agenda-item-text">{{ item.id }}. {{ item.text }}</div>
          </div>
        </v-card-title>
      </v-card>
    </div>
  </div>
</template>

<script>
const collator = new Intl.Collator("en", {
  numeric: true,
  sensitivity: "base"
});

export default {
  props: {
    meeting: Object,
    isOpen: Boolean
  },
  components: {},
  computed: {
    activeAgenda() {
      return this.$store.getters["meetings/getState"].activeAgendaId;
    },
    agendaItems() {
      return this.meeting.agenda.concat().sort((a, b) => {
        return collator.compare(a.id, b.id);
      });
    }
  },
  methods: {
    activateAgenda(item) {
      const agenda = {
        meetingId: this.meeting.id,
        id: item.id
      };
      this.$store.dispatch("meetings/activateAgendaItem", agenda);
    }
  }
};
</script>

<style></style>
